import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import useTable from "../components/useTable";
import { Dimmer } from "../components/spinner";
import { formatMoneda, cmes } from "../util/varios";
import axios from "axios";
import { SearchInput } from "../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";
const CatalogoSaldoBanco = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({
    idplancuenta: "",
  });
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      label: "BANCO",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      color: "white",
    },
    {
      label: "CUENTA BANCARIA",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      color: "white",
    },
    {
      label: "MES",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      color: "white",
    },
    {
      label: "AÑO",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      color: "white",
    },
    {
      label: "MONTO",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      color: "white",
    },
    {
      label: "CODIGO",
      textAlign: "center",
      backgroundColor: "rgb(5, 81, 130)",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idsaldobanco.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              cmes(x.mes).toLowerCase().includes(target.value.toLowerCase()) ||
              x.anio.toLowerCase().includes(target.value.toLowerCase()) ||
              x.cuentabancaria
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let nomtab = "saldobanco";
    let nomid = "idcuentabancaria";
    let nomtab2 = "cuentabancaria";
    let nomid2 = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/consulta/seleccionarregistros3?nomtab=${nomtab}&nomid=${nomid}&nomtab2=${nomtab2}&nomid2=${nomid2}`;

    console.log(endpoint);
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            console.log(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setValues({
      idmoneda: "",
      descripcion: "",
      simbolo: "",
      predeterminada: false,
      valormoneda: "",
    });
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarMoneda = () => {
    props.onHideAceptaCatalogo(values.idsaldobanco);
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();
    setValues({
      idsaldobanco: item.idsaldobanco,
    });
    btnAcepta.current.focus();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant">
        <div className="fw-bold text-light">
          <h3>Seleccionar Saldo en Banco.</h3>
        </div>
        <a type = "button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div className="col-6 m-0 mb-2 p-0">
            <SearchInput onChange={handleSearch}/>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        values.idsaldobanco === item.idsaldobanco
                          ? "lightskyblue"
                          : "white",
                    }}
                    onClick={seleccionarFila(item)}
                  >
                    <td className="py-2 text-start">{item.nombre}</td>

                    <td className="py-2 text-center">{item.cuentabancaria}</td>
                    <td className="py-2 text-start">{cmes(item.mes)}</td>
                    <td className="py-2 text-start">{item.anio}</td>
                    <td className="py-2 text-right">
                      {formatMoneda(
                        item.saldo.toString().replace(".", ","),
                        ",",
                        ".",
                        2
                      )}
                    </td>
                    <td className="py-2 text-start">{item.idsaldobanco}</td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          onClick={seleccionarMoneda}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};

export default CatalogoSaldoBanco;
